module.exports = __webpack_public_path__ + "static/image/service/pc/cartoon@3x.jpg?d687a5b5";